module.exports = __webpack_public_path__ + "img/checked.a31eabbe.svg";